const StoreColumn = () => {

    const columns = [{
        title: 'ردیف', dataIndex: 'row', key: 'row', render: (text, row, index) => {
            return index + 1;
        },
    },

        {
            title: 'محصول',
            dataIndex: 'product',
            key: 'product',
        },
        {
            title: 'کد محصول',
            dataIndex: 'productCode',
            key: 'productCode',
        },


        {
            title: 'تعداد پالت ',
            dataIndex: 'palletsCount',
            key: 'palletsCount',
        },
        {
            title: 'مجموع تعداد در پالت ',
            dataIndex: 'numberInPalletCount',
            key: 'numberInPalletCount',
        },




    ];
    return [columns];
};

export default StoreColumn;